import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.logut';
import * as api from '../../../clients/api';

@Injectable()
export class ApiLogutEffects {

    Logut$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_LOGUT),
        mergeMap((x: ac.PostLogutAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postLogut(x.logoutRequest).pipe(
                map((result: any) => {
                    return new ac.PostLogutErfolgreichAction(result, x.logoutRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostLogutFehlerAction(error, x.logoutRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AccountService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AccountService {
        if (this.service === null) {
            this.service = this.injector.get(api.AccountService);
        }
        return this.service;
    }
}
